import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {adminBusiness} from "../fragments/adminBusiness"

const query = gql`
  query Businesses($q: String, $cursor: String) {
    businesses(q: $q, cursor: $cursor) {
      results {
        ...adminBusiness
      }
      hasMore
      cursor
      limit
    }
  }
  ${adminBusiness}
`

export const businessesKey = getQueryNames(query)[0]

export default query
